import Vue from 'vue';
import 'es6-promise/auto';
import { createApp } from './app';
import * as filters from './plugins/filters'
import ProgressBar from './components/ProgressBar.vue';

// register global utility filters.
Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key]);
});

// global progress bar
const bar = Vue.prototype.$bar = new Vue(ProgressBar).$mount();
document.body.appendChild(bar.$el);

// a global mixin that calls `asyncData` when a route component's params change
Vue.mixin({
    beforeRouteUpdate(to, _, next) {
        const { asyncData } = this.$options;
        if (asyncData) {
            asyncData({
                store: this.$store,
                route: to,
            }).then(next).catch(next);
        } else {
            next();
        };
    },
});
Vue.component("bot-spinner", resolve => require(["@/components/bot/spinner/bot.spinner.vue"], resolve));
Vue.component("bot-date-picker", resolve => require(["@/components/bot/datePicker/bot.date.picker.vue"], resolve));
Vue.component("bot-table", resolve => require(["@/components/bot/table/bot.table.vue"], resolve));
Vue.component("bot-upload-images", resolve => require(["@/components/bot/upload/bot.upload.images.vue"], resolve));

const obj = createApp();
obj.css = require("./plugins/css.js");
const { router, store } = obj;
router.beforeEach((to, _, next) => {
    const vc = require("../vue.config");
    const authRequired = !vc.publicPage.includes(to.path);
    const mem = window.__INITIAL_STATE__.useragent.member;
    // const mem = store.state.useragent.member;
    console.log("to", to.path, `authRequired.${authRequired}`, `mem.${JSON.stringify(mem)}`);
    if (authRequired && !mem) next("/authen/login");
    else next();
});
const app = new Vue(obj);

// prime the store with server-initialized state.
// the state is determined during SSR and inlined in the page markup.
if (window.__INITIAL_STATE__) store.replaceState(window.__INITIAL_STATE__);

// wait until router has resolved all async before hooks
// and async components...

router.onReady(() => {
    // Add router hook for handling asyncData.
    // Doing it after initial route is resolved so that we don't double-fetch
    // the data that we already have. Using router.beforeResolve() so that all
    // async components are resolved.    

    router.beforeResolve((to, from, next) => {
        const matched = router.getMatchedComponents(to);
        const prevMatched = router.getMatchedComponents(from);
        let diffed = false;
        store.dispatch("views/pages/loadData", { href: to.path }).then((page) => {
            if (!page) return;
            document.title = page.PageTitle;
            store.state.useragent.headers.pageKey = page.PageKey;
        });
        const activated = matched.filter((c, i) => {
            return diffed || (diffed = (prevMatched[i] !== c));
        });
        const asyncDataHooks = activated.map(c => c.asyncData).filter(_ => _);
        if (!asyncDataHooks.length) return next();
        bar.start();
        Promise.all(asyncDataHooks.map(hook => hook({ store, route: to }))).then(() => {
            bar.finish();
            next();
        }).catch(next);
    });

    // actually mount to DOM
    app.$mount('#app');
});

// service worker
if (location.protocol === 'https:' && navigator.serviceWorker) navigator.serviceWorker.register('/service-worker.js');



// WEBPACK FOOTER //
// src/entry-client.js